var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Button from '@web/components/layout/Button';
export var ModalHeader = function (_a) {
    var title = _a.title, onClose = _a.onClose;
    return (_jsxs("div", __assign({ className: "flex justify-between items-center gap-8" }, { children: [_jsx("p", __assign({ className: "text-center text-sm sm:text-xl leading-7 font-semibold text-gray-900 mx-auto" }, { children: title })), _jsx(Button, __assign({ variant: "white", type: "button", onClick: onClose, className: "h-8 max-h-8 w-8 max-w-8 self-start justify-self-start items-center" }, { children: '✕' }))] })));
};
